// extracted by mini-css-extract-plugin
module.exports = {"main":"BoardsList_main__zwAAh","container":"BoardsList_container__2_5IR","boards":"BoardsList_boards__opmfd"};